var map = {
	"./cn.json": "5220",
	"./en.json": "de66",
	"./hi.json": "a80e",
	"./hk.json": "29f9",
	"./id.json": "54b9",
	"./ja.json": "2c1f",
	"./ko.json": "4aed",
	"./th.json": "1071",
	"./vi.json": "3d4a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8dc6";